import React, { useEffect, useState } from "react";

import Button from "../../components/Buttons/Button";
import { useNotify } from "../../context/NotificationContext";
import { getPublicCatalogLink } from "../../services/settingsService/settingsService";
import { logger } from "../../utils/logger";
import { useUser } from "../../context/UserContext";
import { showSiteOnlyNotice } from "../../components/siteOnlyAccess";
import {
  ActionGroup,
  Control,
  Hint,
  Input,
  RowLabel,
  SectionAside,
  SectionBody,
  SettingsRow,
  SettingsSection,
} from "./SettingsPage.styles";

const TeacherCatalogLinkSection: React.FC = () => {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const toast = useNotify();
  const { user } = useUser();
  const siteOnly = user?.siteOnly;

  useEffect(() => {
    let active = true;
    if (siteOnly) { setUrl(""); setLoading(false); return; }
    getPublicCatalogLink()
      .then((data) => active && setUrl(data.url))
      .catch((error) => {
        logger.error("Ошибка загрузки личной ссылки преподавателя:", error);
        toast.show({ severity: "error", summary: "Ошибка", detail: "Не удалось получить личную ссылку", life: 3000 });
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [toast, siteOnly]);

  const copy = async () => {
    if (siteOnly) { showSiteOnlyNotice(toast); return; }
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      toast.show({ severity: "success", summary: "Готово", detail: "Ссылка скопирована", life: 2000 });
    } catch (error) {
      logger.error("Ошибка копирования ссылки:", error);
      toast.show({ severity: "error", summary: "Ошибка", detail: "Не удалось скопировать ссылку", life: 3000 });
    }
  };

  return (
    <SettingsSection>
      <SectionAside>
        <h2>Личная ссылка школы</h2>
        <p>По этой ссылке ученик может добавить ваши опубликованные курсы в свой веб-кабинет.</p>
      </SectionAside>
      <SectionBody>
        <SettingsRow>
          <RowLabel>Ссылка</RowLabel>
          <div>
            <Control>
              <Input aria-label="Личная ссылка школы" value={siteOnly ? "Недоступно на тарифе «Только сайт»" : loading ? "Загрузка..." : url} readOnly onClick={() => { if (siteOnly) showSiteOnlyNotice(toast); }} />
            </Control>
            <Hint>
              После подтверждения преподаватель сохраняется в кабинете ученика, и повторно пользоваться ссылкой не нужно.
            </Hint>
          </div>
        </SettingsRow>
        <SettingsRow>
          <RowLabel $tight />
          <ActionGroup>
            <Button type="button" variant="primary" onClick={copy} disabled={!siteOnly && (!url || loading)}>
              Скопировать ссылку
            </Button>
          </ActionGroup>
        </SettingsRow>
      </SectionBody>
    </SettingsSection>
  );
};

export default TeacherCatalogLinkSection;
